import { type, validComps } from '../../utils';
import { $el, bind, getStrTypeAttr, removeAttrs, setHtml } from '../../dom-utils';
import PREFIX from '../prefix';
var PageHeader = /** @class */ (function () {
    function PageHeader() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-page-header', { all: true });
        this._create(this.COMPONENTS);
    }
    PageHeader.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'page-header');
        var backButton = target.querySelector("." + PREFIX.pageHeader + "-back");
        return {
            events: function (_a) {
                var onBack = _a.onBack;
                bind(backButton, 'click', function () {
                    type.isFn(onBack);
                });
            }
        };
    };
    PageHeader.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), title = _a.title, subTitle = _a.subTitle;
            _this._setMainTemplate(node, title, subTitle);
            removeAttrs(node, ['title', 'sub-title']);
        });
    };
    PageHeader.prototype._setMainTemplate = function (node, title, subTitle) {
        var template = "\n        <div class=\"" + PREFIX.pageHeader + "-heading\">\n            <div class=\"" + PREFIX.pageHeader + "-back\">\n                <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-md-arrow-back\"></i>\n            </div>\n            <span class=\"" + PREFIX.pageHeader + "-heading-title\">" + title + "</span>\n            <span class=\"" + PREFIX.pageHeader + "-heading-sub-title\">" + subTitle + "</span>\n        </div>\n        ";
        setHtml(node, template);
    };
    PageHeader.prototype._attrs = function (node) {
        return {
            title: getStrTypeAttr(node, 'title', ''),
            subTitle: getStrTypeAttr(node, 'sub-title', '')
        };
    };
    return PageHeader;
}());
export default PageHeader;
